import React, { Fragment, useState } from 'react';
import { Select, Row } from 'antd';
import { isEmpty } from 'lodash';

const LocationSelect = ({ orderData, orderDataWithLocations={}, record, index, handleOnChange, currentSection, isEditing, isSaved , listData, screenType = "ManageBilling" }) => {
  const [ orderType, setOrderType ] = useState(null);
  const [ orderError, setOrderError ] = useState(null);

  const dataSource = orderData?.type_of_order === "MS" && screenType === "ManageBilling" ? orderDataWithLocations : orderData;
  
  const locationData = dataSource?.locations?.find((id) => id.location_id === record.location_id);
  const ObtainedVal = orderData?.type_of_order === "MS"
    ? `${locationData?.order_type} - ${locationData?.loc_order_sequence || ''}`
    : locationData?.order_type;
  const currentAccesorial = record.accessorial_code
  const currentAccessorialRecords = listData?.filter((i) => i.accessorial_code === currentAccesorial);


  const handleChange = (e) => {
    handleOnChange(index, "location_id", e, currentSection.order_number);
    setOrderType(record.location_id);
  };

  const renderOptions = () => {
    const filteredLocations = isEditing ? dataSource?.locations?.filter((location) => {
      const isLocationSelected = currentAccessorialRecords?.some((record) => record.location_id === location.location_id);
      return !isLocationSelected || location.location_id === record.location_id;
    }) : dataSource?.locations;

    // Sort locations by loc_order_sequence
    const sortedLocations = filteredLocations?.sort((a, b) => {
      const seqA = a.loc_order_sequence || 0;
      const seqB = b.loc_order_sequence || 0;
      return seqA - seqB;
    });

    return sortedLocations?.map((location) => (
      <Select.Option key={ location.location_id } value={ location.location_id }>
        { orderData?.type_of_order === "MS" 
          ? `${location.order_type} - ${location.loc_order_sequence || ''}` 
          : location.order_type 
        }
      </Select.Option>
    ));
  }

  return (
    record.isNew && !isSaved || isEditing ? (
      <Fragment>
        <Select
          showSearch
          value={ record.location_id }
          filterOption={ (input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={ handleChange }
          size="small"
          className="width100Per"
        >
            {renderOptions()}
        </Select>
        { !isEmpty(orderError) && isEmpty(record.location_id) && (
          <Row>
            <span style={ { color: "red", fontSize: "13px" } }>{ orderError }</span>
          </Row>
        ) }
      </Fragment>
    ) : (
      <Fragment>{ ObtainedVal }</Fragment>
    )
  );
};

export default LocationSelect;